class SystemConfigSks {
    static APP_FEE_PERCENTAGE = "AFP"
}

export default SystemConfigSks;
